import { Button } from "@chakra-ui/react";
import React, { useState } from "react";

const LoginButton = ({ texto }) => {
  const [isClicked, setIsClicked] = useState(false);

  const click = () => {
    if (isClicked === false) {
      setIsClicked(true);
      setTimeout(() => {
        setIsClicked(false);
      }, 500);
    } else {
      setIsClicked(false);
    }
  };

  return (
    <Button
      onClick={() => click()}
      w="200px"
      type="submit"
      h="50px"
      borderRadius="5px"
      fontWeight="bolder"
      color="#FFFFFF"
      border="none"
      boxShadow={
        !isClicked
          ? "0px 10px 13px -7px #000000, 1px 43px 2px -30px rgba(255, 255, 255, 0)"
          : "none"
      }
      _hover={{ cursor: "pointer" }}
    >
      {texto}
    </Button>
  );
};

export default LoginButton;
